// ©2024 Austin App House. All rights reserved.
import React from 'react';
import {
  MDBModal,
} from 'mdbreact';
import {connect} from 'react-redux';

const NewApiVersion = ({ modalState }) => (
  <MDBModal
    isOpen={modalState.isOpen}
    position="center"
    centered
    toggle={() => {
    }}
  >
    <div>New Api version is loaded, please refresh page</div>
  </MDBModal>
);

const mapStateToProps = state => ({
  modalState: state.modalState.newApiVersion,
});

export default connect(mapStateToProps)(NewApiVersion);
